import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/reverseTrialPopupQuery.graphql';

export type EntryPointParams = {
	cloudId: string;
	hamsProductKey: string;
};

export const entryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_edition-awareness-reverse-trial-popup" */ './reverse-trial-popup'
			),
		{
			moduleId: 'edition-awareness-reverse-trial-popup',
		},
	),
	getPreloadProps: ({ cloudId, hamsProductKey }: EntryPointParams) => ({
		entryPoints: {},
		extraProps: {},
		queries: {
			reverseTrialPopupQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey,
				},
			},
		},
	}),
});
